/**
 * SF-122 Component 4: race-styled gradient values, extracted from `RaceSelector.tsx` (SF-86) so
 * both it and the new `RaceCrest` badge (`components/shell/RaceCrest.tsx`) import one shared
 * source instead of a copy-pasted literal.
 */
export const RACE_GRADIENTS: Record<string, string> = {
  HUMAN:    'linear-gradient(160deg, #2e2318 0%, #3d3020 100%)',
  ELF:      'linear-gradient(160deg, #162416 0%, #1e3822 100%)',
  DWARF:    'linear-gradient(160deg, #201c14 0%, #302814 100%)',
  ORC:      'linear-gradient(160deg, #2a1410 0%, #3d2010 100%)',
  HALFLING: 'linear-gradient(160deg, #261c0c 0%, #3a2c10 100%)',
  UNDEAD:   'linear-gradient(160deg, #160c20 0%, #241430 100%)',
  AVIAN:    'linear-gradient(160deg, #101828 0%, #183040 100%)',
  FAERY:    'linear-gradient(160deg, #1e0e22 0%, #30142e 100%)',
};
